import React from 'react';
import compose from 'recompose/compose'

import { useLocaleState, useLogout, useTranslate } from 'react-admin';

import { Button } from '@mui/material';
import { RO_APP_TITLE, VERSION_CHECK_DATE } from '../../pages/configuration/actions';
import { getAppVersion } from '../../rest/restClient';
import { getNowDateTimeToFullLocalString } from '../../utils/date';




const RefreshVersionButton = ({
    basePath = '',
    record = {},
    ...rest
}) => {


    const logout = useLogout();
    const [locale, setLocale] = useLocaleState();

    const checkVersion = () => {
        getAppVersion().then(response => {
            if (response && response.json && response.json._embedded && response.json._embedded.software_versions
                && response.json._embedded.software_versions.length === 1
                && response.json._embedded.software_versions[0].software_name === "connect-app"
            ) {
                const software_version = response.json._embedded.software_versions[0].release_version
                if (software_version != process.env.REACT_APP_VERSION) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }).then(required => {
            if (required === true) {
                logout();
            } else {
                console.log("[" + getNowDateTimeToFullLocalString({ locale, showTimezone: true }) + "] [App Version Check] " + process.env.REACT_APP_VERSION);
            }
        })
    }

    // First Time: considered up-to-date
    if (!localStorage.getItem(VERSION_CHECK_DATE)) {
        localStorage.setItem(VERSION_CHECK_DATE, new Date().toISOString())

    } else {
        const tenMinutesAfterCheckDate = new Date(localStorage.getItem(VERSION_CHECK_DATE)).getTime() + 600000;
        const now = new Date().getTime();
        if (now > tenMinutesAfterCheckDate) {
            localStorage.setItem(VERSION_CHECK_DATE, new Date().toISOString())
            checkVersion();
        }
    }







    return (<Button
        // color="primary"
        onClick={() => { }}
        {...rest}
    >
        {`@${localStorage.getItem(RO_APP_TITLE)} ${process.env.REACT_APP_VERSION}`}

    </Button>


    )

};



const enhance = compose(
);

export default enhance(RefreshVersionButton);